module.exports = __webpack_public_path__ + "img/antes_despues_41.6dd3c778.png";